/**
 * The theme's m-select-component only dispatches a non-bubbling "change"
 * event on its hidden native <select>, so variant-picker's ancestor
 * listener (which relies on bubbling) never sees it. On top of that,
 * product-info.js replaces the entire <variant-picker> subtree with a
 * fresh server-rendered copy on every option change (see
 * updateOptionValues/HTMLUpdateUtility.viewTransition in theme-global.js),
 * so any listener bound directly to a specific select node is lost after
 * the first change.
 *
 * A single delegated click listener on document survives that replacement
 * and still fires for the modernized Gender/Size selects added just for
 * this product, keeping price, availability, and variant selection in
 * sync exactly as they are for every other option control.
 */
document.addEventListener("click", function (event) {
  var optionEl = event.target.closest(".m-select-modern .m-select-custom--option");
  if (!optionEl) return;

  var selectComponent = optionEl.closest("m-select-component");
  var nativeSelect = selectComponent && selectComponent.querySelector(".js-selectNative");
  var picker = nativeSelect && nativeSelect.closest("variant-picker");
  if (!nativeSelect || !picker) return;

  // m-select-component's own click handler (bound directly on this option
  // element, re-bound fresh each time its component is re-rendered) runs
  // before this delegated bubble-phase listener and already set
  // nativeSelect.value, so the newly selected <option> is available here.
  var target = nativeSelect.selectedOptions && nativeSelect.selectedOptions[0]
    ? nativeSelect.selectedOptions[0]
    : nativeSelect;

  window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.optionValueSelectionChange, {
    data: {
      selectedOptionValues: picker.selectedOptionValues,
      event: { target: nativeSelect },
      target: target,
    },
  });
});
